import { ToolPanelDef } from '@ag-grid-community/core'
import { FormControl } from '@angular/forms'
import { PanelSettingsToolPanelComponent } from '../panel-settings-tool-panel.component'

export interface PanelSettingsToolPanelParams {
  controls: AdvanceControl[]
}

export interface AdvanceControl {
  label: string
  formControl: FormControl
}

const panelSettingsToolPanelId = 'panelSettingsToolPanel'

/**
 * Creates the configuration needed to show the filter groups tool panel for the grid.
 */
export function createPanelSettingsToolPanel(
  params: PanelSettingsToolPanelParams,
): ToolPanelDef {
  return {
    id: panelSettingsToolPanelId,
    labelDefault: 'Panel Settings',
    labelKey: 'panelSettings',
    iconKey: 'panelSettings',
    toolPanelFramework: PanelSettingsToolPanelComponent,
    toolPanelParams: params,
  }
}
